import React from 'react'
import ReactDOM from 'react-dom'
import '../styles/Loading.css'
import CircularProgress from '@material-ui/core/CircularProgress';
import Colors from '../config/colors'

const Loading = (show) => {

    let view = <div></div>;

    if (show) {
        view = (
            <div className='container-loader'>
                <CircularProgress style={{color: Colors.accent}}/>
            </div>
        );
    }

    ReactDOM.render(view, document.getElementById('loading'));

}

export default Loading